module.exports = __webpack_public_path__ + "static/media/linkedin.155e7acb.svg";